module.exports = __webpack_public_path__ + "img/remove-dash.b768dd94.svg";